import { BPanel, Col, Progress, Button } from '@sketchpixy/rubix';
import React from 'react';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import ReactDOMServer from 'react-dom/server';
import { withRouter } from 'react-router';

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';

import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';

import { getAvailabilityTotalCount, getReservedCount } from '../../helpers/availabilities';

const jQuery = require('jquery');
require('fullcalendar/dist/fullcalendar.js');
require('fullcalendar/dist/locale/fr.js');

@withRouter
export default class CalendarPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};

		this.startDate = moment().startOf('month').toDate();
		this.endDate = moment().endOf('month').toDate();
	}

	componentDidMount() {
		let that = this;
		Tracker.nonreactive(() => {
			jQuery('#calendar').fullCalendar({
				locale: 'fr',
				height: jQuery('#calendar').height(),
				viewRender: (view, element) => {
					console.log("viewRender");
					if (this.startDate == moment(date).startOf('month').toDate()) return ;
					if (this.reloading) return ;
					console.log("pass test");
					
					this.reloading = false;

					const date = jQuery('#calendar').fullCalendar('getDate');
					this.startDate = moment(date).startOf('month').toDate();
					this.endDate = moment(date).endOf('month').toDate();

					this.subscriptions && this.subscriptions.available.stop();
					Tracker.nonreactive(() => {
						console.log("subscription launched");
						this.subscriptions = {};
						this.subscriptions.available = Meteor.subscribe("availableAndScheduledBetween", this.startDate, this.endDate, () => {
							console.log("subscription done");
							this.reloading = true;

							let $calendar = jQuery('#calendar');
							$calendar.fullCalendar('prev');
							$calendar.fullCalendar('next');
							$calendar.fullCalendar('refresh');
							/*let view = $calendar.fullCalendar('getView');
							view.unrenderDates();
							view.renderDates();*/
						});
					});
				},
				dayRender: (momentDate, cell) => {
					let date = momentDate.toDate();

					let anjou = ReactDOMServer.renderToStaticMarkup(
						<div className="calendar">
							<Col sm={6}>
								<p>{getReservedCount(date, "anjou", "morning") + '/' + getAvailabilityTotalCount(date, "anjou", "morning") + " places"}</p>
								<Progress striped bsStyle="info" value={(getReservedCount(date, "anjou", "morning") / getAvailabilityTotalCount(date, "anjou", "morning") * 100)} />
							</Col>
							<Col sm={6}>
								<p>{getReservedCount(date, "anjou", "evening") + '/' + getAvailabilityTotalCount(date, "anjou", "evening") + " places"}</p>
								<Progress striped bsStyle="info" value={(getReservedCount(date, "anjou", "evening") / getAvailabilityTotalCount(date, "anjou", "evening") * 100)} />
							</Col>
						</div>
					);
					let nantes = ReactDOMServer.renderToStaticMarkup(
						<div className="calendar">
							<Col sm={6}>
								<p>{getReservedCount(date, "nantes", "morning") + '/' + getAvailabilityTotalCount(date, "nantes", "morning") + " places"}</p>
								<Progress striped bsStyle="info" value={(getReservedCount(date, "nantes", "morning") / getAvailabilityTotalCount(date, "nantes", "morning") * 100)} />
							</Col>
							<Col sm={6}>
								<p>{getReservedCount(date, "nantes", "evening") + '/' + getAvailabilityTotalCount(date, "nantes", "evening") + " places"}</p>
								<Progress striped bsStyle="info" value={(getReservedCount(date, "nantes", "evening") / getAvailabilityTotalCount(date, "nantes", "evening") * 100)} />
							</Col>
						</div>
					);

					cell.html("<div class='calendar-day'>" + anjou + nantes + "</div>");
				},
				dayClick: function(date, jsEvent, view, resourceObj) {
					if(!_.includes(Meteor.user().roles, 'partner'))
						that.props.router.push('/planning?date=' + date.format());
				}
			});
		});
	}

	componentWillUnmount() {
		this.subscriptions.available.stop();
	}

	render() {
		return (
			<div>
				<BPanel header="Calendrier des disponibilités">
					<Col sm={12}>
						<div id="calendar"></div>
					</Col>  
				</BPanel>
			</div>
		);
	}
}

CalendarPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/Calendar.page.js
 **/